import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-auth',
  styleUrls: ['./layout-auth.layout.scss'],
  templateUrl: './layout-auth.component.html'
})
export class LayoutAuthComponent {}
